var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_49",
    "data-name": "Group 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.234,
    height: 32.234,
    viewBox: "0 0 32.234 32.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M275.941,685.1h-12.76a1.007,1.007,0,0,1,0-2.014h12.76a1.007,1.007,0,0,1,0,2.014Zm0,0",
    transform: "translate(-244.715 -669.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M268.117,691.96a1.007,1.007,0,0,1-.712-1.72l4.324-4.324L267.4,681.59a1.007,1.007,0,0,1,1.424-1.424l5.038,5.036a1.008,1.008,0,0,1,0,1.424l-5.038,5.038a1,1,0,0,1-.712.3Zm0,0",
    transform: "translate(-241.927 -671.814)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M261.763,706.956a2.767,2.767,0,0,1-.833-.125l-8.083-2.693a2.71,2.71,0,0,1-1.828-2.554V677.409a2.688,2.688,0,0,1,2.686-2.686,2.779,2.779,0,0,1,.833.125l8.082,2.692a2.713,2.713,0,0,1,1.83,2.554v24.175a2.689,2.689,0,0,1-2.686,2.687ZM253.7,676.737a.673.673,0,0,0-.671.671v24.175a.7.7,0,0,0,.466.648l8.044,2.681a.731.731,0,0,0,.219.028.673.673,0,0,0,.671-.671V680.094a.7.7,0,0,0-.466-.646l-8.044-2.681a.728.728,0,0,0-.219-.03Zm0,0",
    transform: "translate(-251.018 -674.722)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M270.893,685.467a1.007,1.007,0,0,1-1.006-1.006v-6.044a1.681,1.681,0,0,0-1.679-1.679H253.1a1.007,1.007,0,1,1,0-2.014h15.109a3.7,3.7,0,0,1,3.693,3.693v6.044a1.007,1.007,0,0,1-1.008,1.006Zm0,0",
    transform: "translate(-250.413 -674.722)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M264.692,696.623h-5.373a1.007,1.007,0,0,1,0-2.014h5.373a1.68,1.68,0,0,0,1.679-1.679v-6.042a1.007,1.007,0,1,1,2.014,0v6.042a3.7,3.7,0,0,1-3.693,3.694Zm0,0",
    transform: "translate(-246.897 -668.418)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.03e69297afbd0b4541cb682c234c3abe.svg";
export { ForwardRef as ReactComponent };